///<reference path="../../../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomEase.d.ts"/>
///<reference path="../../../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomWiggle.d.ts"/>

/**
 * Created by Ning Jiang on 3/10/2020.
 */
import {Button, ButtonLike, ButtonState} from "@nolimitcity/slot-game/bin/core/component/Button";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite} from "gsap";
import {Emitter} from "pixi-particles";
import {SoundPlayer} from "../../sound/SoundPlayer";
import {WinterHoardSoundConfig} from "../../WinterHoardSoundConfig";

export interface PickButtonLike extends ButtonLike {
    show:() => void;
    hide:() => void;
    createAnimation:() => void;
    reset:() => void;
}

export class PickButton extends Button {

    private readonly _idleConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0
        },
        "scale" : {
            "start" : 1,
            "end" : 1.5,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"

        },
        "speed" : {
            "start" : 100,
            "end" : 50,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -300
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 80
        },
        "lifetime" : {
            "min" : 1,
            "max" : 2
        },
        "blendMode" : "add",
        "frequency" : 0.1,
        "emitterLifetime" : 0.4,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : true,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -50,
            "y" : 0,
            "w" : 100,
            "h" : 0
        }
    };

    private readonly _overConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0
        },
        "scale" : {
            "start" : 1,
            "end" : 1.5,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"

        },
        "speed" : {
            "start" : 100,
            "end" : 50,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -400
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 80
        },
        "lifetime" : {
            "min" : 1,
            "max" : 2
        },
        "blendMode" : "add",
        "frequency" : 0.1,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : true,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -50,
            "y" : 0,
            "w" : 100,
            "h" : 0
        }
    };

    private readonly _clickConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0
        },
        "scale" : {
            "start" : 1,
            "end" : 1.2,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"

        },
        "speed" : {
            "start" : 100,
            "end" : 50,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -400
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 80
        },
        "lifetime" : {
            "min" : 1,
            "max" : 2
        },
        "blendMode" : "add",
        "frequency" : 0.02,
        "emitterLifetime" : 0.4,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : true,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -50,
            "y" : 0,
            "w" : 100,
            "h" : 0
        }
    };
    private _glowContainer:PIXI.Container;
    private _fsNumber:PIXI.BitmapText;
    private _particleContainer:PIXI.Container;
    private _idleEmitter:Emitter;
    private _isIdleEmitting:boolean;
    private _overEmitter:Emitter;
    private _clickEmitter:Emitter;

    private _animation:PIXI.spine.Spine;
    private _keyword:string;
    private _idleAnimationName:string;
    private _mouseOutAnimation:string;
    private _isFloating:boolean;
    private _floatTween:TimelineLite;
    private _pickCallback:() => void;

    constructor(keyword:string, idleAnimationName:string,mouseOutAnimationName:string, onClickedCallback:() => void) {
        super({
            idle : PIXI.Texture.EMPTY,
            over : PIXI.Texture.EMPTY,
            down : PIXI.Texture.EMPTY,
            disabled : PIXI.Texture.EMPTY,
        }, onClickedCallback, 15);
        this._pickCallback = onClickedCallback;
        this._keyword = keyword;
        this._idleAnimationName = idleAnimationName;
        this._mouseOutAnimation = mouseOutAnimationName;
    }

    protected init():void {
        super.init();
        this.interactiveChildren = false;
        this.hitArea = new PIXI.Rectangle(-190, -240, 380, 480);
    }

    public createAnimation():void {
        this._glowContainer = new PIXI.Container();
        this._animation = new PIXI.spine.Spine(GameResources.getSpineAsset(`intro${this._keyword}`));
        this.addChild(this._animation);
        this._particleContainer = new PIXI.Container();
        this._particleContainer.position.set(0, 240);
        this.addChild(this._particleContainer);
    }

    public set interactiveEnabled(value:boolean) {
        if(this._enabled != value) {
            this._enabled = value;
        }
    }

    public setState(state:ButtonState, autoPlay?:boolean):void {
        super.setState(state, autoPlay);

        this.stopFloat();
        this.stopEmitter();

        switch(state) {
            case ButtonState.idle:
                this.floatMe();
                this.playIdleEmitter();
                break;
            case ButtonState.over:
                this.playOverEmitter();
                break;
            case ButtonState.down:
                this.playMouseDownGlow();
                break;
            case ButtonState.disabled:
                this.stopAll();
                break;
            default:
            // do nothing.
        }
    }

    public setFSNumber(fsLeft:number, visible:boolean, superMode:boolean = false):void {
        if(!this._fsNumber) {
            let fontSizeFS:number = 120;
            if(fsLeft > 9) {
                fontSizeFS = 80;
            }
            this._fsNumber = new PIXI.BitmapText("", {
                fontName : "BHmultiplier",
                fontSize : fontSizeFS,
                tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
            });
            this._fsNumber.maxWidth = 70;
            (<PIXI.Point>this._fsNumber.anchor).set(0.5, 0.5);
            this._fsNumber.position.set(superMode ? -4 : 5, superMode ? 151 : 168);
            this.addChild(this._fsNumber);
        }
        this._fsNumber.text = this.getDisplayNumber(fsLeft);
        this._fsNumber.visible = visible;
    }

    private getDisplayNumber(number:number):string {
        return `${number}`;
    }

    public floatMe():void {
        this._isFloating = true;
        this.loopFloat();
    }

    private loopFloat():void {
        if(!this._isFloating) {
            return;
        }
        CustomWiggle.create("floatWiggle", {wiggles : 15, type : "random"});
        // const random:number = (Math.random() * 2 + 8) * 0.001; // 0.008--0.010

        this._floatTween = new TimelineLite();
        this._floatTween.add([
            TweenLite.to(this.scale, 10, {
                x : `+=0.01`,
                y : `+=0.01`,
                ease : "floatWiggle"
            })]);
        this._floatTween.add(() => this.loopFloat());
    }

    public stopFloat():void {
        this._isFloating = false;
        if(this._floatTween && this._floatTween.isActive()) {
            this._floatTween.progress(1);
        }
        if(this._animation) {
           // this._animation.state.setEmptyAnimation(0, 0);
        }
    }

    public playMouseDownGlow():void {
        if(this._animation) {
            this._animation.state.setAnimation(0, this._mouseOutAnimation, false);
        }
    }

    public reset():void {
        this.scale.set(0.6, 0.6);
        if(this._animation){
            this._animation.tint = 0xffffff;
        }
        if(this._fsNumber) {
            this._fsNumber.tint = 0xffffff;
            this._fsNumber.visible = false;
        }
        if(this._animation) {
            //this._animation.state.setEmptyAnimation(0, 0);
            this._animation.renderable = false;
        }
    }

    public show(animationName:string):void {
        this._animation.renderable = true;
        this._animation.state.setAnimation(0, animationName, false);
        this._animation.state.setAnimation(1, this._idleAnimationName, false);
    }

    public hide():void {
        //this._animation.state.setEmptyAnimation(0, 0);
        this._animation.renderable = false;
    }

    private playClickGlow():void {
        this.stopFloat();
        this._animation.state.setAnimation(0, this._mouseOutAnimation, false);
    }

    protected onUp(replay:boolean = false):void {
        if(!this._enabled) {
            return;
        }
        if(this._currentState != this._downState) {
            if(!replay) {
                this.setState(ButtonState.down);
            }
        }
        this._enabled = false;
            TweenLite.to(this.scale, 0.2, {x:0.8, y:0.8});
                SoundPlayer.playEffect(WinterHoardSoundConfig.PICK_AND_CLICK_EFFECT);
                this.playClickGlow();
                this.playClickEmitter();
        this._pickCallback();
    }

    public click(replay:boolean = false):void {
        if(!replay) {
            this.onUp();
        }
        else {
            this.onUp(replay);
        }
    }

    public showDisable():void {
        this.stopAll();
        this.enabled = false;
        if(this._animation){
            this._animation.tint = 0x555555;
        }

        if(this._fsNumber){
            this._fsNumber.tint = 0x555555;
        }
    }

    public playIdleEmitter():void {
        if(!this._particleContainer) {
            return;
        }
        if(!this._idleEmitter) {
            this._idleEmitter = new Emitter(this._particleContainer, GameResources.getTextures("fsintroParticle"), this._idleConfig);
            ParticlesManager.addEmitter(this._idleEmitter);
        }
        this._isIdleEmitting = true;
        this.loopEmit();
    }

    private loopEmit():void {
        if(!this._isIdleEmitting) {
            return;
        }

        this._idleEmitter.emit = true;
        TweenLite.to(this, 1 + Math.random() * 2, {onComplete : () => this.loopEmit()});
    }

    private playOverEmitter():void {
        if(!this._animation) {
            TweenLite.to(this, 0.1, {x:0.7, y:0.7});
            return;
        }

        if(!this._particleContainer) {
            return;
        }

        if(!this._overEmitter) {
            this._overEmitter = new Emitter(this._particleContainer, GameResources.getTextures("fsintroParticle"), this._overConfig);
            ParticlesManager.addEmitter(this._overEmitter);
        }
        this._overEmitter.emit = true;
    }

    public playClickEmitter():void {
        if(!this._particleContainer) {
            return;
        }

        if(!this._clickEmitter) {
            this._clickEmitter = new Emitter(this._particleContainer, GameResources.getTextures("fsintroParticle"), this._clickConfig);
            ParticlesManager.addEmitter(this._clickEmitter);
        }
        this._clickEmitter.emit = true;
    }

    private stopEmitter():void {
        if(this._idleEmitter) {
            this._idleEmitter.emit = false;
        }
        this._isIdleEmitting = false;

        if(this._overEmitter) {
            this._overEmitter.emit = false;
        }
    }

    private stopAll():void {
        this.stopFloat();
        this.stopEmitter();
        if(this._clickEmitter) {
            this._clickEmitter.emit = false;
        }
    }
}